<template>
  <div class="dashboard" >
    <v-container class="my-5">
      <v-layout wrap row justify-start class="mb-3">
        <v-flex xs6  pa-1>
          <v-text-field
            label="Search By Code, SKU, ..."
            hide-details
            solo
            v-model="searchText"
            @input="filterHurtOrders()"
          ></v-text-field>
        </v-flex>
        <v-flex xs3 pa-1>
          <v-autocomplete
            name="Source Warehouse"
            label="Source Warehouse"
            solo :loading="loading"
            hide-details
            item-text="name"
            clearable
            @change="filterHurtOrders()"
            :items="warehouses"
            v-model.trim="warehouse"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 pa-1>
          <v-autocomplete
            name="SKU"
            label="SKU"
            solo :loading="loading"
            @change="filterHurtOrders()"
            :items="products"
            item-text="sku"
            clearable
            item-value="sku"
            hide-details
            v-model.trim="product"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3 pa-1>
          <v-menu
            v-model="cDate"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="fcreate_date"
                label="From Date"
                append-icon="event"
                @change="filterHurtOrders()"
                readonly
                solo :loading="loading"
                clearable
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="fcreate_date" @change="filterHurtOrders()" @input="cDate = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs3 pa-1>
          <v-menu
            v-model="tcDate"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tcreate_date"
                label="To Date"
                append-icon="event"
                @change="filterHurtOrders()"
                readonly
                solo :loading="loading"
                clearable
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="tcreate_date" @change="filterHurtOrders()" @input="tcDate = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 px-1>
          <v-btn color="primary" block large @click="exportPos()">export</v-btn>
        </v-flex>
        <v-flex xs2 px-1>
          <v-btn color="primary" block large @click="goTo(`/move`)">new</v-btn>
        </v-flex>
      </v-layout>
      <div v-if="loading" class="text-xs-center">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12>
            <span> {{ filteredHurtOrders.length}} Results </span>
            <div class="text-xs-center">
              <v-pagination
                v-model="currentPage"
                :length="pagesNumber"
                :total-visible="5"
                @input="updateVisible"
              ></v-pagination>
            </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12 v-for="po in visibleHurtOrders" :key="po.key" mb-1>
          <v-card>
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">KEY</div>
                  <div class="subheadline"
                    v-clipboard:copy="po.key"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
                  >{{ po.key }}</div>
                </v-flex>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">Creator</div>
                  <div class="subheadline">{{ po.user }}</div>
                </v-flex>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">CREATE DATE</div>
                  <div class="subheadline">{{ po.date }}</div>
                </v-flex>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">WH</div>
                  <div class="subheadline"
                    v-clipboard:copy="po.wh"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
                  >{{ po.wh }}</div>
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-expansion-panel expand>
                    <v-expansion-panel-content>
                      <div slot="header">ITEMS</div>
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-layout row wrap class="text-xs-left">
                                <v-flex xs3>
                                  <div style="font-size:10px;font-weight:600;">SKU</div>
                                </v-flex>
                                <v-flex xs3>
                                  <div style="font-size:10px;font-weight:600;">QT.</div>
                                </v-flex>
                                <v-flex xs3 px-1>
                                  <div style="font-size:10px;font-weight:600;">PRICE</div>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 v-for="(item, it) in po.items" py-1 :key="'item-'+it">
                              <v-layout row wrap class="text-xs-left">
                                <v-flex xs3
                                  v-clipboard:copy="item.sku"
                                  v-clipboard:success="clipboardSuccessHandler"
                                  v-clipboard:error="clipboardErrorHandler"
                                >
                                  {{item.sku}}
                                </v-flex>
                                <v-flex xs3>
                                  {{item.quantity}}
                                </v-flex>
                                <v-flex xs3 px-1>
                                  {{item.price}}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
                
              </v-layout>
            </v-card-text>
            <v-card-actions dense>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark small @click="goTo(`/purchase/${po.key}`)">Edit</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12>
          <div class="text-xs-center">
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="7"
              @input="updateVisible"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      
    </v-container>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import axios from 'axios';
import json2csv from 'json2csv'

export default {
  data() {
    return {
      searchText:'',
      loading:false,
      currentPage: 1,
      pageSize: 7,
      pagesNumber:0,
      hurtorders:[],
      filteredHurtOrders:[],
      visibleHurtOrders:[],
      vendors:[],
      warehouses:[],
      products:[],
      vendor:null,
      warehouse:null,
      product:null,
      status:null,
      fcreate_date:null,
      cDate:null,
      tcDate:null,
      tcreate_date:null,
      invoicers:[],
      invoice_by:null,
    }
  },
  props:{
    uid:{
      default:null
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
		updateVisible() {
      this.sortByDate()
      this.visibleHurtOrders = this.filteredHurtOrders.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredHurtOrders = this.filteredHurtOrders.sort((a, b)=>a.timestamp - b.timestamp)
    },
    getPagesNumber(){
      if (this.filteredHurtOrders.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredHurtOrders.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredHurtOrders.length / this.pageSize) + 1
      }
		},
		filterHurtOrders() {
      this.loading = true
			this.filteredHurtOrders = this.hurtorders
      .filter(x=>{
        if(this.searchText){
          this.searchText = this.searchText.toLowerCase()
          for (const key in x) {
            if (Object.hasOwnProperty.call(x, key) && typeof x[key] == 'string') {
              if(x[key] && x[key].toLowerCase().includes(this.searchText)) {
                return x
              }
            }
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.warehouse) {
          if(x.wh == this.warehouse) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{
        if(this.product) {
          if(x.items.map(x=>x.sku).includes(this.product)) {
            return x
          }
        } else {
          return x
        }
      })
      .filter(x=>{ // create date
        if(!this.fcreate_date) return x
        if(!this.tcreate_date) return x
        let t = new Date(x.date).getTime()
        let z = new Date(this.fcreate_date).getTime()
        let y = new Date(this.tcreate_date).getTime()
        if (t >= z && t <= y) return x
      })
      this.getPagesNumber()
      this.currentPage = 1
			this.updateVisible()
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async getHurtOrders(){
      this.loading = true
      let hurtorders = await store.collection(`hurtorders`).get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return {
          ...y.data(), 
          key:y.id,
        }
      }))
      console.log(hurtorders)
      this.hurtorders = hurtorders
      this.filterHurtOrders()
    },
    async loadVendors(){
      this.loading = true
      let a = await db.ref('settings/vendors').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.vendors = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
      }
      this.vendor = {}
      this.loading = false
    },
    async getWarehouses(){
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>y.data()))
      console.log(this.warehouses)
      this.loading = false
    },
    async loadProducts(){
      this.loading = true
      let a = await db.ref(`productsCoreLite`)
			.once('value').then(x=>x.val())
      let b = Object.keys(a)
      let c = Object.values(a).map((x,i)=>{
        return {
          ...x, 
          key:b[i],
        }})
      this.products = c
      this.loading = false
    },
    async LoadInvoices(){
      let a = await db.ref('settings/invoiceby').once('value').then(x=>x.val())
      if(a) {
        let b = Object.values(a).map(x=>x.name)
        this.invoicers = b
      }
    },
    exportData(data, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'po_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    exportPos() {
      let pos = this.filteredHurtOrders
      console.log(pos)
      let epo = [];
      for (let i = 0; i < pos.length; i++) {
        const po = pos[i];
        let ks = Object.keys(po).filter(x=> typeof po[x] == 'string')
        let dpo = {}
        ks.forEach(x=> dpo[x] = po[x])
        let post = po.status_timeline ? Object.values(po.status_timeline) : []
        let postst = {}
        post.forEach(x=>postst[x.status]=x.date)
        console.log(dpo)
        for (let h = 0; h < po.rec_items.length; h++) {
          const item = po.rec_items[h];
          let a = {
            ...dpo,
            ...po.v,
            ...item,
            ...postst,
            quantity_expected:po.items.filter(x=>x.sku == item.sku).length?po.items.filter(x=>x.sku == item.sku)[0].quantity:0,
            received:true,
          }
          epo.push(a)
        }
      }
      this.exportData(epo)
    }
  },
  watch:{
    
  },
  created(){
    this.loadProducts()
    this.getWarehouses()
    this.loadVendors()
    this.LoadInvoices()
    this.getHurtOrders()
  }
}
</script>

<style>

</style>
